var cov_16mmtrn9mf = function () {
  var path = "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Transfer/styles/index.ts",
      hash = "6861ad2a90ed59afac527a63a3d14e193b96231b",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/10008649/Desktop/workspace/fe/shein/shineout/src/Transfer/styles/index.ts",
    statementMap: {
      "0": {
        start: {
          line: 5,
          column: 29
        },
        end: {
          line: 5,
          column: 65
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();


var transferLess = {};
import genaration from '../../utils/classname';
export var transferClass = (cov_16mmtrn9mf.s[0]++, genaration(transferLess, 'transfer'));